import _assign from "object-assign";

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import { isPlainObject } from './internal/isPlainObject';
import { useDescendant } from './internal/DescendantContext';
import { useListItem } from './useListItem';
import ListItemBase from './ListItemBase';
var ListItem = /*#__PURE__*/forwardRef(function (props, ref) {
  var children = props.children,
      _props$item = props.item,
      item = _props$item === void 0 ? props.item === undefined && !isPlainObject(children) ? children : props.item : _props$item,
      restProps = _objectWithoutProperties(props, ["children", "item"]);

  var _useListItem = useListItem(_assign({
    index: useDescendant(item),
    item: item
  }, restProps)),
      itemToString = _useListItem.itemToString,
      itemProps = _useListItem.itemProps;

  var itemText = itemToString(item);
  return /*#__PURE__*/React.createElement(ListItemBase, _assign({
    ref: ref,
    tooltipText: itemText
  }, itemProps), children !== undefined ? children : itemText);
});
process.env.NODE_ENV !== "production" ? ListItem.propTypes = {
  /**
   * The content of the item.
   */
  children: PropTypes.node,

  /**
   * The className(s) of the component.
   */
  className: PropTypes.string,

  /**
   * Useful to extend the style applied to components.
   */
  classes: PropTypes.objectOf(PropTypes.string),

  /**
   * The density of a component affects the style of the layout.
   *
   * A high density component uses minimal sizing and spacing to convey the intended UI design.
   * Conversely, a low density component, maximizes the use of space and size to convey the UI Design.
   */
  density: PropTypes.oneOf(['touch', 'low', 'medium', 'high']),

  /**
   * If `true`, the component will be disabled.
   */
  disabled: PropTypes.bool,

  /**
   * Object used for the item.
   */
  // eslint-disable-next-line react/forbid-prop-types
  item: PropTypes.any,

  /**
   * Item `toString` function when the item prop is used.
   *
   * If omitted, component will look for a `label` property on the data object.
   *
   * @param {object} item The item.
   */
  itemToString: PropTypes.func
} : void 0;
export default ListItem;